module.exports = __webpack_public_path__ + "img/6379bb3.png";